import Vue from 'vue';
import message from './index.vue';
const messageConstructor = Vue.extend(message);
let messagePool = [];
let getAnInstance = () => {
  if(!messagePool.length) {
    return new messageConstructor({
      el: document.createElement('div')
    });
  }
  return messagePool[0];
}

let returnAnInstance = (instance) => {
  if (messagePool.length) {
    return;
  }
  if (instance) {
    messagePool.push(instance);
  }
}

let messageBox = (options = {}) => {
  options.isSubtitle = !!options.isSubtitle;
  let instance = getAnInstance();
  instance = Object.assign(instance, options);
  if (!messagePool.length) {
    document.body.appendChild(instance.$el);
  }
  returnAnInstance(instance);
  return instance;
}

export default messageBox;



// WEBPACK FOOTER //
// ./src/plugins/memberGuide/index.js